import type { CmtsHttpClient } from "../api/cmtsHttpClient.js";
import { CMTS_API } from "../api/cmtsApiPaths.js";
import { repositoryCall } from "./repositoryResult.js";

export const CMTS_LEGACY_REPORT_PATHS = {
  complaintRegister: CMTS_API.reportsLegacy.complaintRegister,
  slaBreach: CMTS_API.reportsLegacy.slaBreach,
  ageing: CMTS_API.reportsLegacy.ageing,
  openComplaints: CMTS_API.reportsLegacy.openComplaints,
  nearBreach: CMTS_API.reportsLegacy.nearBreach,
  ownerWise: CMTS_API.reportsLegacy.ownerWise,
  departmentWise: CMTS_API.reportsLegacy.departmentWise,
  categoryWise: CMTS_API.reportsLegacy.categoryWise,
  severityWise: CMTS_API.reportsLegacy.severityWise,
  sourceWise: CMTS_API.reportsLegacy.sourceWise,
  plantWise: CMTS_API.reportsLegacy.plantWise,
  customer: CMTS_API.reportsLegacy.customer,
  supplier: CMTS_API.reportsLegacy.supplier,
  customerComplaints: CMTS_API.reportsLegacy.customerComplaints,
  supplierComplaints: CMTS_API.reportsLegacy.supplierComplaints,
  rcaCapaLinkage: CMTS_API.reportsLegacy.rcaCapaLinkage,
  closureVerification: CMTS_API.reportsLegacy.closureVerification,
  repeat: CMTS_API.reportsLegacy.repeat,
  repeatComplaints: CMTS_API.reportsLegacy.repeatComplaints,
  reopen: CMTS_API.reportsLegacy.reopen,
  auditLog: CMTS_API.reportsLegacy.auditLog,
  managementSummary: CMTS_API.reportsLegacy.managementSummary,
} as const;
export type CmtsLegacyReportCode = keyof typeof CMTS_LEGACY_REPORT_PATHS;

export function createLegacyReportRepository(client: CmtsHttpClient) {
  return {
    query: (code: CmtsLegacyReportCode, query?: Record<string, unknown>) => repositoryCall(() => client.get<unknown>(CMTS_LEGACY_REPORT_PATHS[code], { query: query as Record<string, string | number | boolean | undefined> }), `CMTS_LEGACY_REPORT_${String(code).toUpperCase()}`),
    typed: (code: string, query?: Record<string, unknown>) => repositoryCall(() => client.get<unknown>(CMTS_API.reportsLegacy.typed(code), { query: query as Record<string, string | number | boolean | undefined> }), `CMTS_TYPED_GET_REPORT_${code.toUpperCase()}`),
    export: (payload: Record<string, unknown>) => repositoryCall(() => client.post<unknown>(CMTS_API.reportsLegacy.export, payload), "CMTS_LEGACY_REPORT_EXPORT"),
    saveConfiguration: (payload: Record<string, unknown>) => repositoryCall(() => client.post<unknown>(CMTS_API.reportsLegacy.configurations, payload), "CMTS_REPORT_CONFIGURATION_SAVE"),
  };
}
